<template>
  <div class="language-switcher">
    <select
      v-model="currentLanguage"
      @change="switchLanguage"
      class="lang-select"
      :title="'切换语言 / Switch Language'"
    >
      <option value="zh">中文</option>
      <option value="en">EN</option>
      <option value="ja">日本語</option>
      <option value="ko">한국어</option>
    </select>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { detectPreferredLocale } from '../constants/locales';

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n();
    const router = useRouter();

    // 获取用户的语言偏好（复用常量模块，避免与 router 重复实现）
    locale.value = detectPreferredLocale();

    const switchLanguage = () => {
      // 保存到localStorage
      localStorage.setItem('language', locale.value);
      
      // 更新URL路径
      const currentPath = router.currentRoute.value.fullPath;
      const newPath = currentPath.replace(/^\/(zh|en|ja|ko)/, `/${locale.value}`);
      if (currentPath === newPath) {
        // 如果当前URL没有语言前缀，则添加
        router.push(`/${locale.value}${currentPath}`);
      } else {
        router.push(newPath);
      }
    };

    return {
      currentLanguage: locale,
      switchLanguage
    };
  }
};
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
}

/* 配色对齐 header：墨黑底 + 暖灰字 + 黄铜描边，圆角与搜索框一致 */
.lang-select {
  background: transparent;
  color: #d4cfc8;
  border: 1px solid rgba(212, 207, 200, 0.25);
  border-radius: 4px;
  padding: 0.4rem 0.5rem;
  font-size: 0.85rem;
  font-family: var(--font-sans, -apple-system, system-ui, "PingFang SC", sans-serif);
  line-height: 1;
  cursor: pointer;
  transition: color 0.3s ease, border-color 0.3s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-align: center;
  text-align-last: center;
  -webkit-text-align-last: center;
  -moz-text-align-last: center;
  max-width: 90px;
  width: auto;
  box-sizing: border-box;
}

/* 悬停/聚焦：文字提亮 + 黄铜描边，与搜索框聚焦态呼应 */
.lang-select:hover,
.lang-select:focus {
  color: #f5f5f5;
  border-color: var(--brass, #b39a6b);
  outline: none;
}

/* 下拉选项沿用墨黑底，避免原生浅色弹层破坏整体气质 */
.lang-select option {
  background: var(--ink, #1b1815);
  color: #f5f5f5;
}
</style>